/**
 * Function that returns
 * an API error action in a
 * standardized format, so that
 * the error actions are consistent
 * across different api requests
 */
import { path } from 'ramda';

export const apiErrorActionCreator = (type) => (
  response = {},
  otherProperties = {}
) => {
  const { metricsInfo, status, problem, config: { method } = {} } = response;
  // If any nested properties are undefined,
  // message will be undefined and
  // the property will not be added.
  const message = path(['data', 'errors', 'base'], response);
  return {
    type,
    payload: {
      response: {
        status,
        problem,
        method,
        message,
        metricsInfo
      },
      ...otherProperties
    }
  };
};

export default apiErrorActionCreator;
